<div class="rank-chip">
	<span class="small">{{ rankNumber }}</span>
	<mat-icon *ngIf="userData===1" svgIcon="first-rank-star"></mat-icon>
	<mat-icon *ngIf="userData===2" svgIcon="second-rank-star"></mat-icon>
	<mat-icon *ngIf="userData===3" svgIcon="third-rank-star"></mat-icon>
</div>